import CandidateExpertiseItem, {
  CandidateExpertiseItemProps,
} from './CandidateExpertiseItem.container';

export type CandidateExpertiseItemType = CandidateExpertiseItemProps;

export default CandidateExpertiseItem;
